// TODO: remove once all cards componentized - all functionality should be in it's relative card/component

import { getIn } from 'formik';

import { Control } from '../../components';
import { updateField } from '../../store/customer';
import { CONTROL_TYPE, countries } from '../../utils/constants';
import { VALIDATION } from '../../utils/validation';
import { CARD_CATEGORIES } from './constants';
export function defaultAddressFields(t, category, store = {}, multiShipToIndex = 0) {
  let isStateRequired = false;
  const countryArray = ['BR', 'US', 'CA'];
  const { odata: { countryList } = {} } = store;
  if (store && Object.keys(store).length !== 0) {
    const { customer } = store;

    if (category === 'shipTo') {
      const { [category]: multiShipToData = [] } = customer;
      const { address: { country } = {} } = multiShipToData[multiShipToIndex];
      if (countryArray.includes(country)) {
        isStateRequired = true;
      }
    } else {
      if (category === 'bankReference') {
        const { [category]: { country } = {} } = customer;
        isStateRequired = country && countryArray.includes(country);
      } else {
        const { [category]: { address: { country } } = {} } = customer;
        isStateRequired = country && countryArray.includes(country);
      }
    }
  }
  return [
    {
      field: 'country',
      label: t('address.country.label'),
      options: countryList || countries
    },
    {
      field: 'street',
      label: t('address.street.label'),
      validations: [{ type: VALIDATION.maxCharacters, param: 175 }]
    },
    {
      field: 'city',
      label: t('address.city.label'),
      validations: [{ type: VALIDATION.maxCharacters, param: 35 }]
    },
    {
      field: 'state',
      label: t('address.state.label'),
      required: isStateRequired
    },
    {
      field: 'zipCode',
      label: t('address.zipCode.label'),
      validations: [{ type: VALIDATION.maxCharacters, param: 10 }]
    }
  ];
}

// const checkbankReference = (category, customer, countryArray, isDistrictRequired) => {
//   if (category === 'bankReference') {
//     // const { [category]: { country } = {} } = customer;
//     // return (isDistrictRequired = country && countryArray.includes(country));
//     return (isDistrictRequired = false);
//   } else {
//     const { [category]: { address: { country } } = {} } = customer;
//     return (isDistrictRequired = country && countryArray.includes(country));
//   }
// };

const getConditionalEMEAField = (t, required, category) =>
  category === 'bankReference'
    ? []
    : [
        {
          field: 'district',
          label: t('address.district.label'),
          validations: [{ type: VALIDATION.maxCharacters, param: 35 }],
          required: required
        }
      ];
function emeaStateRequired(category, customer, countryArray, multiShipToIndex = 0) {
  let isStateRequired = false;
  if (category === 'shipTo') {
    const { [category]: multiShipToData = [] } = customer;
    const { address: { country } = {} } = multiShipToData[multiShipToIndex];
    if (countryArray.includes(country)) {
      isStateRequired = true;
    }
  } else {
    if (category === 'bankReference') {
      const { [category]: { country } = {} } = customer;
      isStateRequired = country && countryArray.includes(country);
    } else {
      const { [category]: { address: { country } } = {} } = customer;
      isStateRequired = country && countryArray.includes(country);
    }
  }
  return isStateRequired;
}

function emeaDistrictRequired(category, isDistrictArray, store, multiShipToIndex = 0) {
  let isDistrictRequired = false;
  const { customer } = store;
  const { [category]: { address: { country = '' } = {} } = {} } = customer;
  const {
    customer: { region = '' }
  } = store;

  if (category && country === 'TR') {
    isDistrictRequired = country && isDistrictArray.includes(country);
  }
  if (category === 'shipTo' && region === 'EMEA') {
    const { [category]: multiShipToData = [] } = customer;
    const { address: { country = '' } = {} } = multiShipToData[multiShipToIndex];
    isDistrictRequired = country && isDistrictArray.includes(country);
  }
  return isDistrictRequired;
}

export function emeaAddressFields(t, category, store = {}, multiShipToIndex = 0) {
  let isDistrictRequired = false;
  const isStateCountryArray = ['BR', 'US', 'CA'];
  const isDistrictArray = ['TR'];
  const { customer } = store;
  const { odata: { countryList } = {} } = store;
  let isStateRequiredField = false;
  if (category === 'bankReference') {
    isDistrictRequired = false;
  }
  if (store && Object.keys(store).length !== 0) {
    isStateRequiredField = emeaStateRequired(category, customer, isStateCountryArray, multiShipToIndex);
    isDistrictRequired = emeaDistrictRequired(category, isDistrictArray, store, multiShipToIndex);
  }

  return [
    {
      field: 'country',
      label: t('address.country.label'),
      required: category === 'bankReference' ? false : true,
      options: countryList || countries
    },
    {
      field: 'street',
      label: t('address.street.label'),
      required: category === 'bankReference' ? false : true,
      validations: [{ type: VALIDATION.maxCharacters, param: 175 }]
    },
    {
      field: 'city',
      label: t('address.city.label'),
      validations: [{ type: VALIDATION.maxCharacters, param: 35 }],
      required: category === 'bankReference' ? false : true
    },
    {
      field: 'state',
      label: t('address.state.label'),
      required: isStateRequiredField
    },
    {
      field: 'zipCode',
      label: t('address.zipCode.label'),
      required: category === 'bankReference' ? false : true,
      validations: [{ type: VALIDATION.maxCharacters, param: 10 }]
    },
    ...getConditionalEMEAField(t, isDistrictRequired, category)
    // {
    //   field: 'district',
    //   label: t('address.district.label'),
    //   validations: [{ type: VALIDATION.maxCharacters, param: 60 }],
    //   required: category === 'bankReference' ? [] : isDistrictRequired,
    // },
  ];
}

function getShipToValidations(category, customer, multiShipToIndex, countryArray) {
  const { [category]: multiShipToData = [] } = customer;
  const { address: { country = '' } = {} } = multiShipToData[multiShipToIndex];
  if (countryArray.includes(country)) {
    return {
      stateRequired: true
    };
  } else {
    return { stateRequired: false };
  }
}

const getConditionalLatamField = (isMX, t, required) =>
  isMX
    ? []
    : [
        {
          field: 'district',
          label: t('address.district.label'),
          validations: [{ type: VALIDATION.maxCharacters, param: 35 }],
          required
        }
      ];

export function latamAddressFields(t, category, store, multiShipToIndex = 0) {
  let cityDropDownRequired = false;
  let isMXUser = false;
  let isBrUser = false;
  let isAddressFieldRequired = false;
  let isStateRequired = false;
  const {
    odata: { countryList }
  } = store;
  if (store) {
    const { customer } = store;
    const { [category]: { address: { country = '' } = {} } = {}, countryCode } = customer;
    isMXUser = countryCode === 'MX';
    isBrUser = countryCode === 'BR';
    isAddressFieldRequired = isMXUser || isBrUser;
    const countryArray = ['BR', 'US', 'CA', 'MX'];
    if (category === 'bankReference') {
      isAddressFieldRequired = false;
      isMXUser = true;
      isBrUser = false;
    }
    if (countryArray.includes(country)) {
      isStateRequired = true;
    }
    switch (category) {
      case 'shipTo': {
        const { stateRequired } = getShipToValidations(category, customer, multiShipToIndex, countryArray);
        isStateRequired = stateRequired;
        break;
      }
      case 'soldTo':
        if (countryArray.includes(country)) {
          cityDropDownRequired = country === 'BR';
        }
        break;
      default:
        break;
    }
  }

  return [
    {
      field: 'country',
      label: t('address.country.label'),
      required: isAddressFieldRequired,
      options: countryList || countries
    },
    {
      field: 'street',
      label: t('address.street.label'),
      required: isAddressFieldRequired,
      validations: [{ type: VALIDATION.maxCharacters, param: 175 }]
    },
    {
      field: 'city',
      label: t('address.city.label'),
      validations: [{ type: VALIDATION.maxCharacters, param: 35 }],
      required: isAddressFieldRequired,
      type: cityDropDownRequired ? CONTROL_TYPE.citySelect : CONTROL_TYPE.addressField
    },
    {
      field: 'state',
      label: t('address.state.label'),
      required: isStateRequired
    },
    {
      field: 'zipCode',
      label: t('address.zipCode.label'),
      required: isAddressFieldRequired,
      validations: [{ type: VALIDATION.maxCharacters, param: 10 }]
    },
    ...getConditionalLatamField(isMXUser, t, isBrUser)
  ];
}
/**
 * @param {string} category - Category of the address (soldToAddress, billToAddress, etc)
 * @returns {Array[Object]} - Returns category address config array
 */
export function getAddressConfigByCategory(category, t, store, isCardOptional = false, multiShipToIndex, disabled) {
  let addressFields = defaultAddressFields;
  if (store) {
    const {
      customer: { region = '' }
    } = store;
    const currentRegion = region && region.toLowerCase();
    switch (currentRegion) {
      case 'latam':
        addressFields = latamAddressFields;
        break;
      case 'na':
        addressFields = defaultAddressFields;
        break;
      case 'emea':
        addressFields = emeaAddressFields;
        break;
      default:
        addressFields = defaultAddressFields;
        break;
    }
  }
  return addressFields(t, category, store, multiShipToIndex).map(item => ({
    category: CARD_CATEGORIES[category],
    required: CARD_CATEGORIES[category] === 'bankReference' ? false : !isCardOptional,
    type: CONTROL_TYPE.addressField,
    disabled,
    additionalProps: {
      placeholder: item.placeholder ? item.placeholder : item.label
    },
    ...item
  }));
}
/**
 * @param {string} key - field name
 * * @param {function} t - translation function
 * * @param {boolean} disabled - field disable state
 * * @param {string} maxChar - field max character limit
 * @returns {boolean} required - required field validation
 */
export const getAddressFieldConfig = (key, t, _disabled, maxChar, category, required = false, fieldType = null) => ({
  field: key,
  category,
  label: t(`address.${key}.label`),
  validations: maxChar ? [{ type: VALIDATION.maxCharacters, param: maxChar }] : [],
  required,
  type: fieldType ? fieldType : null,
  additionalProps: {
    placeholder: t(`address.${key}.placeholder`)
  }
});
/**
 * @property {Object[]} configs - Array of configs from formConfig list
 * @property {Object} store - Redux Store
 * @function dispatch - Triggers reducers and updates the store based on action
 * @property {APIService} apiService - Service to make request to the api
 * @property {string} cardId - Id of card for identifying if it is on editMode
 * @returns {ReviewField[]} - Array of ReviewField components
 */
export function mapPageFields(configs, store, formik, cardId) {
  if (cardId === CARD_CATEGORIES.deliveryDetails) {
    return mapPageDeliveryDetailsFields(configs, store);
  }
  return configs.map((config, index) => {
    const {
      field,
      category,
      type,
      label,
      required,
      additionalProps,
      validations,
      addressFields,
      requiredGroupFields,
      onChecked,
      onCheckboxClicked,
      options,
      selectChildren,
      onChange,
      initialSelectState,
      disabled
    } = config;
    const isAddressOrRequiredGroup = type === CONTROL_TYPE.address || type === CONTROL_TYPE.requiredGroup;
    let hasError;
    const errorMessage = getIn(formik.form.errors, category);

    // Boolean to check if field name has error, ignore errors from children
    if (errorMessage?.method === 'Required at least one field' && window.location.href.includes('review')) {
      hasError = true;
    }
    const name = isAddressOrRequiredGroup ? category : `${category}.${field}`;
    const props = {
      validations,
      name,
      type,
      label,
      required,
      addressFields,
      requiredGroupFields,
      onChecked,
      onCheckboxClicked,
      options,
      selectChildren,
      hasGroupError: hasError,
      onChange,
      initialSelectState,
      ...additionalProps,
      disabled,
      category,
      field
    };
    return <Control key={`${name}-${index}`} {...props} />;
  });
}
/**
 * @property {Object[]} configs - Array of configs from formConfig list
 * @property {Object} store - Redux Store
 * @property {string} cardId - Id of card for identifying if it is on editMode
 * @returns {ReviewField[]} - Array of ReviewField components
 */
export function mapPageDeliveryDetailsFields(configs, store) {
  return configs.map((config, index) => {
    // Dynamically setting required for these fields based on appointmentRequired
    const onCheckboxClicked = formik =>
      setTimeout(() => formik.form.setFieldTouched(CARD_CATEGORIES.deliveryDetails, true));
    const { field, category, type, label, additionalProps, validations, addressFields } = config;
    const name = `${category}.${field}`;
    const required = getIn(store.customer, 'deliveryDetails.appointmentRequired');
    const props = {
      validations,
      name,
      type,
      label,
      required,
      addressFields,
      onCheckboxClicked,
      ...additionalProps
    };
    return <Control key={`${name}-${index}`} {...props} />;
  });
}
/**
 * @property {Array} fieldsToEmpty - an array of fields to empty
 * @function dispatch - Triggers reducers and updates the store based on action
 * @property {Object} formik - The formik object used to set fields.
 */
export async function emptyOutFields(fieldsToEmpty, dispatch, formik) {
  return new Promise(resolve => {
    fieldsToEmpty.forEach(({ name, value }) => {
      dispatch(updateField({ name, value }));
      formik.form.setFieldValue(name, value);
    });
    resolve();
  });
}
/**
 *
 * @param {String} value - value of the changed input
 * @param {Function} dispatch Triggers reducers and updates the store based on action
 * @param {Object} formik - The formik object used to set filds
 * @param {Object} apiService - the apiService used to updateCustomers
 * @param {Object} store - the current store
 * @param {String} category - The contact category that is being changed (i.e. 'invoiceDelivery')
 * @param {String} fieldToEmpty - The field on the category (i.e. 'email')
 */
export async function contactInputEmpty(
  { value, dispatch, formik, apiService, store },
  category,
  fieldToEmpty,
  fieldEmptyVal
) {
  const field = getIn(store.customer, `${category}.${fieldToEmpty}`);
  if ((value !== '' && getIn(store.customer, `${category}.mailToBillTo`)) || (field && field.length)) {
    await emptyOutFields(
      [
        { name: `${category}.mailToBillTo`, value: false },
        { name: `${category}.${fieldToEmpty}`, value: fieldEmptyVal }
      ],
      dispatch,
      formik
    );
    await apiService.updateCustomer(store.customer, dispatch);
  }
}
export function selectWithChildrenContactOnChange({ dispatch, formik, fieldsToUpdate, category }) {
  return new Promise(res => {
    fieldsToUpdate.forEach(({ name, value }) => {
      formik.form.setFieldValue(`${category}.${name}`, value);
      dispatch(updateField({ name: `${category}.${name}`, value: value }));
    });
    res();
  });
}
export function buildSameAsContactFieldArray(value, options) {
  const returnArr = [];
  let shouldEmptyOtherFields = false;
  options.forEach(name => {
    returnArr.push({ name, value: name === value });
  });
  shouldEmptyOtherFields = true;
  returnArr.push({ name: 'method', value });
  return [returnArr, shouldEmptyOtherFields];
}
export function getValueFromMapping(category, map) {
  let value;
  Object.keys(map).forEach(key => {
    if (category && category[key]) {
      value = map[key];
    }
  });
  return value;
}
